import React from 'react';
import { Player } from '../types';
import { Heart } from 'lucide-react';

interface PlayerPanelProps {
  player: Player;
  isActive: boolean;
  maxHealth?: number;
}

const PlayerPanel: React.FC<PlayerPanelProps> = ({ player, isActive, maxHealth = 3 }) => {
  return (
    <>
    <div 
      className={`
        flex flex-col items-center justify-center p-2 md:p-4 rounded-xl border-2 transition-all duration-300 w-full sm:w-64
        ${isActive 
          ? `border-${player.color}-500 bg-${player.color}-900/20 shadow-[0_0_10px_rgba(0,0,0,0.5)] md:shadow-[0_0_20px_rgba(0,0,0,0.5)] scale-100 md:scale-105` 
          : 'border-neutral-800 bg-neutral-900/50 opacity-60'
        }
      `}
    >
      <h2 className={`text-xs md:text-2xl font-orbitron font-bold tracking-wider mb-1 md:mb-2 whitespace-nowrap overflow-hidden text-ellipsis w-full text-center ${isActive ? 'text-white' : 'text-neutral-500'}`}>
        {player.name}
      </h2>

      {/* Health indicator (heart shape) */}
      <div className="flex gap-1 md:gap-2 mb-1 md:mb-2 flex-wrap justify-center max-w-[120px] md:max-w-[200px]">
        {Array.from({ length: maxHealth }).map((_, i) => (
          <Heart
            key={i}
            className={`w-4 h-4 md:w-6 md:h-6 transition-all duration-300 
              ${i < player.health 
                ? `fill-${player.color}-500 text-${player.color}-500` 
                : 'fill-transparent text-neutral-700'}`}
          />
        ))}
      </div>

      {isActive && (
        <div className={`mt-1 md:mt-3 text-[9px] md:text-xs uppercase tracking-[0.2em] animate-pulse text-${player.color}-400 hidden md:block`}>
          Current Turn
        </div>
      )}
    </div>

    {/* Attempts: three bars with small gaps below the panel */}
    <div className="w-full sm:w-64 mt-2 md:mt-3 flex gap-0.5 md:gap-1">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className={`flex-1 h-1 md:h-1.5 rounded-sm transition-colors duration-300
            ${i < player.attemptsLeft
              ? (isActive ? `bg-${player.color}-500` : 'bg-neutral-700')
              : 'bg-neutral-800/60'}`}
        />
      ))}
    </div>
    </>
  );
};

export default PlayerPanel;